<button type="button" class="btn btn-default" (click)="generateCustomInvoice()">
  <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>Factures douane <i class="far fa-file-pdf"></i>
</button>
